// login.nthround.io appends "/" to the path it forwards to, so a link whose path carries a query (an emailed
// /actions/action/?wf_exec_id=… link) lands with a slash on its last value: wf_exec_id=EXEC-…/. Imported first in
// index.js, so the address is fixed before any page reads it.

/** The href without the slash(es) login appends after its query, or null when there's nothing to trim. */
export function trimmedQueryHref(href) {
	const url = new URL(href);
	if (!/\/+$/.test(url.search)) return null;
	url.search = url.search.replace(/\/+$/, '');
	return url.href;
}

if (typeof window !== 'undefined' && window.location) {
	try {
		const fixed = trimmedQueryHref(window.location.href);
		if (fixed) window.history.replaceState(window.history.state, '', fixed);
	} catch {
		// leave the address as it is
	}
}
